export const roleTypes = [
  {
    type: "college_students",
    title: "College Student",
  },
  {
    type: "professionals",
    title: "Professional",
  },
  {
    type: "business_owners",
    title: "Business Owner",
  },
  {
    type: "board_members",
    title: "Board Member",
  },
]
export const activityTypes = [
  {
    type: "freshman",
    title: "Freshman",
  },
  {
    type: "sophomores",
    title: "Sophomore",
  },
  {
    type: "juniors_seniors",
    title: "Juniors Senior",
  },
  {
    type: "graduate_students",
    title: "Graduate Student",
  },
  {
    type: "freelancers",
    title: "Freelancer",
  },
  {
    type: "middle_managers",
    title: "Middle Manager",
  },
  {
    type: "recent_graduates",
    title: "Recent Graduate",
  },
  {
    type: "rising_executives",
    title: "Rising Executive",
  },
  {
    type: "senior_executives",
    title: "Senior Executive",
  },
  {
    type: "founders",
    title: "Founder",
  },
  {
    type: "mature",
    title: "Mature",
  },
  {
    type: "startups",
    title: "Startup",
  },
  {
    type: "board_of_directors",
    title: "Board of Directors",
  },
  {
    type: "diverse_company",
    title: "Company",
  },
  {
    type: "board_associates",
    title: "Board Advisors",
  },
]
export const genderTypes = [
  {
    type: "female",
    title: "Female",
  },
  {
    type: "male",
    title: "Male",
  },
]
export const raceTypes = [
  {
    type: "black_african_american",
    title: "Black/African-American",
  },
  {
    type: "american_indian",
    title: "American Indian/Alaskan Native",
  },
  {
    type: "asian",
    title: "Asian",
  },
  {
    type: "native_hawaiian",
    title: "Native Hawaiian/Pacific Islander",
  },
  {
    type: "hispanic",
    title: "Hispanic/Latino",
  },
  {
    type: "white",
    title: "White",
  },
]
export const companyRoleTypes = [
  {
    type: "corporations",
    title: "Corporation",
  },
  {
    type: "small_emerging_business_or_supplier",
    title: "Small & Emerging Business or Supplier",
  },
  {
    type: "financial_organizations",
    title: "Financial Services",
  },
  {
    type: "government_agency_public_entity",
    title: "Government Agency, Public Entity",
  },
  {
    type: "nonprofit",
    title: "Non-Profit",
  },
  {
    type: "dc_education",
    title: "Education",
  },
  {
    type: "professional",
    title: "Professional",
  },
  {
    type: "other",
    title: "Other",
  },
]
export const companyActivityTypes = [
  {
    type: "small",
    title: "Small",
  },
  {
    type: "medium",
    title: "Medium",
  },
  {
    type: "large",
    title: "Large",
  },
  {
    type: "black_student_unions",
    title: "Black Student Union",
  },
  {
    type: "civic_organizations",
    title: "Civic Organization",
  },
  {
    type: "hbcus",
    title: "HBCU",
  },
  {
    type: "professional_organizations",
    title: "Professional Organization",
  },
  {
    type: "sororities_and_fraternities",
    title: "Sorority & Fraternity",
  },
  {
    type: "trade_associations",
    title: "Trade Association",
  },
  {
    type: "for_profit_board_of_directores_and_advisors",
    title: "For-profit Board of Directors & Advisors",
  },
  {
    type: "non_profit_board_of_directores_and_advisors",
    title: "Nonprofit Board of Directors & Advisors",
  },
  {
    type: "private_clubs_and_associations",
    title: "Private Clubs & Associations",
  },
  {
    type: "banking",
    title: "Banking",
  },
  {
    type: "angel_investors",
    title: "Angel investors",
  },
  {
    type: "incubators",
    title: "Debt Financing",
  },
  {
    type: "working_capital_financing",
    title: "Working Capital Financing",
  },
  {
    type: "mergers_and_acquisitions",
    title: "Merger & Acquisition",
  },
  {
    type: "private_acquity",
    title: "Private Equity",
  },
  {
    type: "wealth_management",
    title: "Wealth Management",
  },
  {
    type: "venture_capital",
    title: "Venture Capital",
  },
  {
    type: "family_offices",
    title: "Family Offices",
  },
  {
    type: "initial_public_offering",
    title: "Initial Public Offering",
  },
  {
    type: "businesses",
    title: "Business",
  },
  {
    type: "executives",
    title: "Executive",
  },
  {
    type: "professionals",
    title: "Professional",
  },
  {
    type: "students",
    title: "Student",
  },
  {
    type: "chief_operating_officers",
    title: "Chief Operating Officer",
  },
  {
    type: "chief_procurement_officers",
    title: "Chief Procurement Officer",
  },
  {
    type: "logistic_executives",
    title: "Logistics Executive",
  },
  {
    type: "operations_executives",
    title: "Operations Executive",
  },
  {
    type: "supplier_diversity_managers",
    title: "Supplier Diversity Manager",
  },
  {
    type: "diversity_and_inclusion",
    title: "Diversity & Inclusion",
  },
  {
    type: "officers",
    title: "Officer",
  },
  {
    type: "hr_practitioners",
    title: "HR Practitioner",
  },
  {
    type: "hiring_managers",
    title: "Hiring Manager",
  },
  {
    type: "supplier_diversity",
    title: "Supplier Diversity",
  },
  {
    type: "managers",
    title: "Manager",
  },
  {
    type: "vp_engineering",
    title: "VP, Engineering",
  },
  {
    type: "vp_product_marketing",
    title: "VP, Product Marketing",
  },
]
export const companyIndustryTypes = [
  {
    type: "administrative_services",
    title: "Administrative Services",
  },
  {
    type: "airlines",
    title: "Airlines",
  },
  {
    type: "advertising",
    title: "Advertising",
  },
  {
    type: "apparel",
    title: "Apparel",
  },
  {
    type: "automotive",
    title: "Automotive",
  },
  {
    type: "arts_entertainment_and_recreation",
    title: "Arts, Entertainment & Recreation",
  },
  {
    type: "beauty",
    title: "Beauty",
  },
  {
    type: "broadcasting",
    title: "Broadcasting (except internet)",
  },
  {
    type: "construction",
    title: "Construction",
  },
  {
    type: "data_processing_hosting_and_related_services",
    title: "Data processing, hosting & related services",
  },
  {
    type: "education",
    title: "Education",
  },
  {
    type: "financial_services_and_insurance",
    title: "Financial Services & Insurance",
  },
  {
    type: "food_services",
    title: "Food Services",
  },
  {
    type: "governance_strategic_development",
    title: "Governance & Strategic Development",
  },
  {
    type: "government",
    title: "Government",
  },
  {
    type: "healthcare",
    title: "Healthcare",
  },
  {
    type: "human_resources",
    title: "Human Resources",
  },
  {
    type: "infrastructure",
    title: "Infrastructure",
  },
  {
    type: "it_digital",
    title: "Information Technology & Digital",
  },
  {
    type: "legal",
    title: "Legal",
  },
  {
    type: "leisure_and_hospitality",
    title: "Leisure & Hospitality",
  },
  {
    type: "distribution",
    title: "3PL & Distribution",
  },
  {
    type: "manufacturing",
    title: "Product Development & Manufacturing",
  },
  {
    type: "management_of_companies_and_enterprises",
    title: "Management of Companies & Enterprise",
  },
  {
    type: "marketing",
    title: "Marketing & Communications",
  },
  {
    type: "media",
    title: "Media",
  },
  {
    type: "professional_and_business_services",
    title: "Professional Business Services & Consulting",
  },
  {
    type: "professional_scientific_and_technical_services",
    title: "Professional, Scientific & Technical Services",
  },
  {
    type: "public_relations",
    title: "Public Relations",
  },
  {
    type: "real_estate",
    title: "Real Estate",
  },
  {
    type: "retail_trade",
    title: "Retail Trade",
  },
  {
    type: "software_development",
    title: "Software Development",
  },
  {
    type: "technology",
    title: "Technology",
  },
  {
    type: "telecommunications",
    title: "Telecommunications",
  },
  {
    type: "transportation",
    title: "Transportation",
  },
  {
    type: "wholesale_trade",
    title: "Wholesale Trade",
  },
]
export const companyDepartmentTypes = [
  {
    type: "finance_and_accounting",
    title: "Finance & Accounting",
  },
  {
    type: "human_resources",
    title: "Human Resources",
  },
  {
    type: "procurement_or_purchasing",
    title: "Procurement/Purchasing",
  },
  {
    type: "business_development_and_sales",
    title: "Business Development & Sales",
  },
  {
    type: "marketing_and_public_relations",
    title: "Marketing & Public Relations",
  },
  {
    type: "administration_and_management",
    title: "Administration & Management",
  },
  {
    type: "operations",
    title: "Operations",
  },
  {
    type: "technology",
    title: "Technology",
  },
  {
    type: "customer_service_support",
    title: "Customer Service Support",
  },
  {
    type: "legal",
    title: "Legal",
  },
  {
    type: "distribution",
    title: "Distribution",
  },
  {
    type: "research_and_development",
    title: "Research & Development",
  },
]
export const companyDiverseType = [
  {
    title: "Yes",
    type: "yes",
  },
  {
    title: "No",
    type: "no",
  },
]
export const companyVerificationTypes = [
  {
    type: "b2t_verified",
    title: "B2T Verified",
  },
  {
    type: "industry_verified",
    title: "Industry Verified",
  },
]
